import { render } from "./Thesistitla.vue?vue&type=template&id=cfe417dc&scoped=true"
import script from "./Thesistitla.vue?vue&type=script&lang=js"
export * from "./Thesistitla.vue?vue&type=script&lang=js"

import "./Thesistitla.vue?vue&type=style&index=0&id=cfe417dc&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfe417dc"]])

export default __exports__